import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { HttpBackendService } from 'src/app/core/backend-services/http/http.backend-service';

@Injectable({
  providedIn: 'root',
})
export class GameStatisticsBackendService {
  private readonly BASE_ADDRESS = '/statistics';

  /**
   * @description constructor of GameStatisticsBackendService
   * @param {HttpBackendService} http - http backend service
   */
  constructor(private http: HttpBackendService) {}

  /**
   * @description gets game statistics
   * @returns {Promise<any[]>}
   */
  public getGameStatistics(): Promise<
    {
      usersOnline: number;
      totalUsers: number;
      roundsPlayed: number;
      newUsersIn24h: number;
    }[]
  > {
    return firstValueFrom(
      this.http.get<
        {
          usersOnline: number;
          totalUsers: number;
          roundsPlayed: number;
          newUsersIn24h: number;
        }[]
      >(`${this.BASE_ADDRESS}`)
    );
  }

  /**
   * @description gets rankings
   * @param {string} period - period for rankings: 'today', 'this_week', 'this_month', 'yesterday', 'last_week', 'last_month', 'all_time'
   * @param {string} gameType - game type: '2_player', '3_player', '4_player', 'all'
   * @returns {Promise<any>}
   */
  public getRankings(period: string = 'all_time', gameType: string = 'all'): Promise<any> {
    const params = new URLSearchParams();
    params.set('period', period);
    params.set('gameType', gameType);
    return firstValueFrom(this.http.get<any>(`${this.BASE_ADDRESS}/rankings?${params.toString()}`));
  }
}
